import { Box, Button, Grid2, styled, Chip, Menu, MenuItem } from "@mui/material";

export const QuickFilterBox = styled(Box)(({ highlighted }) => ({
    borderRadius: "8px",
    border: "1px solid #E6E6E6",
    borderColor: highlighted ? "#6D72F6" : "#E6E6E6",
    padding: "8px 14px",
    backgroundColor: highlighted ? "#F7F7FF" : "#FFFFFF",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
}));

export const ActionGrid = styled(Grid2)(() => ({
    border: '1px solid #E6E6E6',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    padding: '24px',
    flexDirection: 'column',
    gap: '16px'
}));

export const BmsFaultsAnalyticsContainer = styled(Box)({
    width: '100%',

    '& .apexcharts-legend-group-vertical': {
        flexDirection: 'row !important',
    }
});

export const StyledAction = styled(Button)(() => ({
    padding: '3px 12px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E6E6E6',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    textTransform: 'none',
    minWidth: 0,

    '&:hover': {
        border: '1px solid #6D72F6',

        '& span': {
            color: '#6D72F6'
        },

        '& svg path': {
            fill: '#6D72F6'
        }
    }
}));

export const FilterChip = styled(Chip)(() => ({
    backgroundColor: "#FFFFFF",
    border: "1px solid #D7D7D7",
    height: "28px",
    fontSize: "12px",
    fontWeight: 500,
    borderRadius: "14px",
    maxWidth: "240px",                 // <--- set your max width here

    "& .MuiChip-label": {
        maxWidth: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingRight: "8px",             // space before delete icon
    },

    "& .MuiChip-deleteIcon": {
        fontSize: "12px !important",
        color: "#474747 !important",
        padding: "3px",
        borderRadius: "50%",
        flexShrink: 0,                    // <--- prevents icon from shrinking
        "&:hover": {
            backgroundColor: "#EAEAEA !important",
            color: "#930500 !important",
        },
    },
}));

// Shared styled components for breakdown charts
export const GroupByButton = styled(Button)({
    fontSize: "12px",
    color: "#686868",
    fontWeight: 400,
    lineHeight: "12px",
    textTransform: "uppercase",
    maxWidth: "90%",
    borderRadius: "8px",
    border: "none",
    justifyContent: "space-between",

    "&:hover": {
        backgroundColor: "#F0F0F0",
    },

    "& .MuiButton-endIcon": {
        marginLeft: "auto",
        "& .MuiSvgIcon-root": {
            color: "#686868",
            fontSize: "20px !important",
        },
    },
});

export const DropdownMenu = styled(Menu)({
    "& .MuiPaper-root": {
        minWidth: "150px",
        padding: "4px 12px",
        borderRadius: "10px",
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.08)",
        marginTop: "4px",
    },
});

export const GroupByMenuItem = styled(MenuItem)({
    padding: "8px 12px",
    fontWeight: 400,
    fontSize: "14px",
    color: "#3D4B5A",
    backgroundColor: "#FFFFFF",
    borderRadius: "4px",
    lineHeight: "16px",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
        color: "#3D4B5A",
        backgroundColor: "#F9F9F9",
    },
    "&.Mui-selected": {
        fontWeight: 500,
        color: "#4D44D8",
        backgroundColor: "#EFF0FF",
        "&:hover": {
            backgroundColor: "#EFF0FF",
        },
    },
});

// Group by options constant
export const GROUP_BY_OPTIONS = [
    { value: "originCity", label: "By City" },
    { value: "originState", label: "By State" },
    { value: "originDepot", label: "By Depot" },
    { value: "configName", label: "By Project" },
    { value: "cellChemistry", label: "By Cell Chemistry" },
    { value: "hierarchy", label: "By Entity" },
    { value: "fleetName", label: "By Customer Account" },
    { value: "fleetCategory", label: "By Business Segment" },
];
